export const ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS = {
	tourSeenAt: 'enhance-orientation-tour:tourSeenAt',
	hasDismissedTour: 'enhance-orientation-tour:hasDismissedTour',
	hasCompletedTour: 'enhance-orientation-tour:hasCompletedTour',
	hasSeenFinishNudge: 'enhance-orientation-tour:hasSeenFinishNudge',
} as const;

export const EnhanceOrientationOnboardingKeys = [
	...Object.values(ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS),
] as const;
